import { useContext, useEffect } from "react";
import {
  Box,
  Heading,
  VStack,
  Button,
  Text,
  Spinner,
  HStack,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { UserProfileContext } from "../../context/UserContext";
import { hasUserType, USER_TYPES } from "../../utils/userRole";
import EstateList from "../../components/AccountSwitcher/EstateList";

const SelectAccount = () => {
  console.log("Rendering SelectAccount");
  const { userProfile, isLoading, setActiveAccount } =
    useContext(UserProfileContext) || {};
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (!isLoading) {
      const estates = Array.isArray(userProfile?.estates)
        ? userProfile.estates
        : [];

      // if user only has one primary estate -> skip selection
      if (estates.length === 1 && estates[0]?.isPrimary) {
        setActiveAccount({
          type: "estate",
          estateId: estates[0].estateId?._id || estates[0].estateId,
          name: estates[0].estateId?.name || estates[0].name,
          isPrimary: true,
        });
        navigate("/dashboard");
        return;
      }

      // if no estates and not a VTU user, go to dashboard
      const isVtu = hasUserType(userProfile, USER_TYPES.VTU_USER);
      if (estates.length === 0 && !isVtu) {
        navigate("/dashboard");
      }
    }
  }, [isLoading, userProfile, navigate]);

  const handleChooseEstate = (estate) => {
    const acc = {
      type: "estate",
      estateId: estate?.estateId?._id || estate?.estateId,
      name: estate?.estateId?.name || estate?.name,
    };
    setActiveAccount?.(acc);
    toast({
      title: `Switched to ${estate?.estateId?.name || estate?.name}`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    navigate("/dashboard");
  };

  const handleChooseVTU = () => {
    const acc = { type: "vtu" };
    setActiveAccount?.(acc);
    toast({
      title: `Switched to VTU account`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    navigate("/dashboard");
  };

  if (isLoading)
    return (
      <Box p={6} textAlign="center">
        <Spinner />
      </Box>
    );

  const estates = Array.isArray(userProfile?.estates)
    ? userProfile.estates
    : [];
  const isVtu = hasUserType(userProfile, USER_TYPES.VTU_USER);

  // If no selection needed, component will have redirected in useEffect

  return (
    <Box p={6} maxW="800px" mx="auto">
      <VStack align="start" spacing={4}>
        <Heading size="lg">Continue as</Heading>
        <Text>Select the account you want to use for this session.</Text>

        <EstateList
          estates={estates}
          onSelectEstate={handleChooseEstate}
          isVtu={isVtu}
          onSelectVtu={handleChooseVTU}
          buttonLabel="Continue"
        />
      </VStack>
    </Box>
  );
};

export default SelectAccount;
